<template>
    <div id="checkout-payment-wari" class="tab-pane fade"
         :class="{ show: chosenMethod, active: chosenMethod }" role="tabpanel">
        <div class="row align-items-center">
            <div class="col-12 col-md-8">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input c-pointer" v-model="accepted"
                           type="checkbox" id="accept-wari">
                    <label v-html="$t('checkout.payment.acceptWari', generalInfos)"
                           class="custom-control-label c-pointer" for="accept-wari"></label>
                </div>
            </div>
            <div class="col-12 col-md-4 text-center">
                <button @click="setBillingMethod" class="btn btn-primary" :disabled="!accepted">
                    {{$t("checkout.payment.payWithWari")}}
                </button>
            </div>
        </div>
        <transition name="fade">
            <div v-if="accepted" class="row">
                <div class="col-12 text-center">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input v-model="saveAsFavoritePaymentMethod" class="custom-control-input c-pointer" type="checkbox" id="favorite-payment-method-wari">
                        <label class="custom-control-label c-pointer" for="favorite-payment-method-wari">
                            {{ $t("CheckoutPayment.favoritePaymentMethod") }}
                        </label>
                    </div>
                    <RequiredForOneClickOrder/>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import wari from "../../../../assets/img/payments/wari.png";
import RequiredForOneClickOrder from "../../../shared/Order/RequiredForOneClickOrder";

export default {
    name: "CheckoutPaymentWari",
    components: {RequiredForOneClickOrder},
    props: {
        generalInfos: {
            type: Object,
            required: true,
        },
        preferences: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            accepted: false,
            wari,
            saveAsFavoritePaymentMethod: this.preferences.billing.method === "wari",
        };
    },
    computed: {
        chosenMethod() {
            return this.order.billing.method === "wari";
        },
    },
    methods: {
        setBillingMethod() {
            this.$emit("set-billing-method", {
                method: "wari",
                favoritePaymentMethod: this.saveAsFavoritePaymentMethod,
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>